// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionInstanceSearchResponse

import { hydrateSessionInstance, type SessionInstance, type SessionInstanceApiResponse } from './sessionInstance.gen';

export type SessionInstanceSearchApiResponse = {
	items: SessionInstanceApiResponse[];
};

export type SessionInstanceSearch = {
	items: SessionInstance[];
};

export function hydrateSessionInstanceSearch(data: SessionInstanceSearchApiResponse): SessionInstanceSearch {
	return {
		...data,
		items: data.items.map(hydrateSessionInstance),
	};
}